import Reveal from "./Reveal";

const SectionHeading = ({ title, eyebrow }) => (
  <div className="mb-16 md:mb-20" data-testid={`section-heading-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
    <Reveal>
      <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#F5F5FA] tracking-wide">{title}</h2>
      <span className="mt-6 block h-px w-20 bg-gradient-to-r from-[#D4AF37]/60 to-transparent" />
    </Reveal>
    {eyebrow && (
      <Reveal delay={0.1}>
        <p className="mt-6 max-w-xl text-sm md:text-base font-light leading-relaxed text-[#A0A0B0]">{eyebrow}</p>
      </Reveal>
    )}
  </div>
);

export default SectionHeading;
